import { useEffect, useState } from 'react';

// T362 — the first debounce in this frontend, and it exists for a reason the
// other five search boxes do not have.
//
// Applications, Dashboard, Documents, the facet dropdown and the command
// palette all filter an array that is already in memory, so a keystroke costs a
// synchronous pass over a few hundred rows and debouncing would only add lag.
// Mail search asks the server, so a keystroke costs a round trip — typing
// "kubernetes" would fire ten of them, and the answers can arrive out of order.
export function useDebounced(value, ms = 250) {
  const [settled, setSettled] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setSettled(value), ms);
    return () => clearTimeout(t);
  }, [value, ms]);
  return settled;
}
